import request from './request'

export function dashboardSummary() {
  return request({ url: '/api/dashboard/summary', method: 'get' })
}

export function dashboardMonthly() {
  return request({ url: '/api/dashboard/monthly', method: 'get' })
}

export function dashboardRecent() {
  return request({ url: '/api/dashboard/recent', method: 'get' })
}
